import React, { useState } from 'react';

const NewsletterSignup = ({ variant = 'default' }) => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    // TODO: integrate with email service (Mailchimp, ConvertKit, etc.)
    try {
      // Simulate API call
      await new Promise(resolve => setTimeout(resolve, 1000));
      console.log('Newsletter signup:', email);
      setSubmitted(true);
      setEmail('');
    } catch (err) {
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (variant === 'compact') {
    return (
      <div className="newsletter-compact">
        <h3>Newsletter</h3>
        <p>Get updates on projects, research, and events.</p>
        <form onSubmit={handleSubmit} className="newsletter-form-compact">
          <input
            type="email"
            placeholder="Your email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            disabled={loading}
          />
          <button type="submit" disabled={loading}>
            {loading ? '...' : 'Subscribe'}
          </button>
        </form>
        {submitted && (
          <p className="newsletter-success">Thanks for subscribing!</p>
        )}
        {error && <p className="newsletter-error">{error}</p>}
      </div>
    );
  }

  return (
    <section className="newsletter-section">
      <div className="container">
        <div className="newsletter-container">
          <div className="newsletter-content">
            <h2 className="section-title-centered">Stay Connected</h2>
            <p className="newsletter-description">
              Subscribe to our newsletter to receive updates on new projects, research publications, events, and opportunities to collaborate.
            </p>
            
            <form onSubmit={handleSubmit} className="newsletter-form">
              <div className="form-group">
                <input
                  type="email"
                  placeholder="Your email address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  disabled={loading}
                />
                <button type="submit" disabled={loading}>
                  {loading ? 'Subscribing...' : 'Subscribe'}
                </button>
              </div>
              <p className="newsletter-note">
                No spam, unsubscribe anytime.
              </p>
            </form>
            
            {submitted && (
              <div className="newsletter-success-full">
                <i className="fas fa-check-circle"></i>
                <p>Thank you for subscribing! Check your inbox for confirmation.</p>
              </div>
            )}
            
            {error && (
              <div className="newsletter-error-full">
                <p>{error}</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewsletterSignup;